import { yupResolver } from '@hookform/resolvers/yup';
import { ISwitchFormMeta } from '@Modules/admin/integrationSettings/containers/forms/switch/SwitchFormMeta';
import { CustomButton } from '@Modules/core/components';
import CustomFormControl from '@Modules/core/components/form/CustomFormControl';
import CustomNumberInput from '@Modules/core/components/form/CustomNumberInput';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { useForm } from 'react-hook-form';
import { FaSave } from 'react-icons/fa';
import { BankCorporateInputs } from './BankCorporateInputs';

type Props = {
  onSubmit: any,
  meta: ISwitchFormMeta,
  isLoading?: boolean,
  isSubmitting: boolean,
};

export const SwitchFormUI = ({ meta, onSubmit, isLoading, isSubmitting }: Props) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    // reset,
  } = useForm({ resolver: yupResolver(meta.schema),});

  const displayNumberInputs = (inputs: string[]) => {
    return inputs.map((input, index) => {
      return (
        <CustomFormControl key={index} isLoading={isLoading} label={meta[input as keyof ISwitchFormMeta].label} isInvalid={!!errors[meta[input as keyof ISwitchFormMeta].name]}>
          <CustomNumberInput hasError={errors[meta[input as keyof ISwitchFormMeta].name]} register={register(meta[input as keyof ISwitchFormMeta].name)} meta={meta[input as keyof ISwitchFormMeta]}/>
        </CustomFormControl>
      )
    })
  }

  return (
    <CC.Box shadow={'lg'} p={"2em"} w='full'>
      <CC.Heading as='h1' size={'md'}   mb="1%">
        Règles de Priorité du Routage
      </CC.Heading>
      <form onSubmit={handleSubmit(onSubmit)}>
        <BankCorporateInputs register={register} hasError={errors} />
        <CC.Flex direction={{base: 'column', md: 'row'}} >
          <CC.Box mt="2%" mr={'5%'} as="fieldset"
        p={'2%'} border={'1px solid var(--chakra-colors-gray-300)'} w={{base: 'full', md: '50%'}}>
            <CC.Heading px={2} as={"legend"} fontSize='md'>Priorité Nationnal</CC.Heading>
            <CC.Grid templateColumns={{base: 'repeat(1, 1fr)', md: 'repeat(3, 1fr)'}} gap={4}>
              {displayNumberInputs(['nPriorityBIN', 'nPriorityApplicationCard', 'nPriorityTransactionType', 'nPriorityWithOrWithoutPIN'])}
            </CC.Grid>
          </CC.Box>
          <CC.Box mt="2%" as="fieldset"
        p={'2%'} border={'1px solid var(--chakra-colors-gray-300)'} w={{base: 'full', md: '50%'}}>
            <CC.Heading px={2} as={"legend"} fontSize='md'>Priorité Internationnal</CC.Heading>
            <CC.Grid templateColumns={{base: 'repeat(1, 1fr)', md: 'repeat(3, 1fr)'}} gap={4}>
              {displayNumberInputs(['iPriorityAssociation', 'iPriorityCardTypeNetwork', 'iPriorityApplicationCard', 'iPriorityTransactionType', 'iPriorityWithOrWithoutPIN'])}
            </CC.Grid>
          </CC.Box>
        </CC.Flex>
        <CC.Flex justify={'end'} mt={'1em'}>
          <CustomButton isLoading={isSubmitting} type='submit'><FaSave style={{marginRight: '10px'}} /> Sauvegarder</CustomButton>
        </CC.Flex>
      </form>
    </CC.Box>
  );
};